import { create } from "zustand";

/** 同意が必要な文書。id は "terms-of-service" / "privacy-policy" / "device-cancellation-policy"。 */
export interface PendingAgreement {
	id: string;
	version: string;
}

interface AgreementAcceptanceState {
	/** 同意が必要な文書。空なら同意済み (または不要)。同意後の再読み込みまで戻さない。 */
	pending: PendingAgreement[];
	/** 「デバイスを追加」の前に同意が必要な文書 (キャンセルポリシー)。同意済みなら null。 */
	deviceAgreement: PendingAgreement | null;
	require: (agreements: PendingAgreement[]) => void;
	setDeviceAgreement: (agreement: PendingAgreement | null) => void;
}

export const useAgreementAcceptanceStore = create<AgreementAcceptanceState>((set) => ({
	pending: [],
	deviceAgreement: null,
	require: (agreements) => set({ pending: agreements }),
	setDeviceAgreement: (agreement) => set({ deviceAgreement: agreement }),
}));
